module.exports = __webpack_public_path__ + "img/partybuilding.8586d767.png";